(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[927],{

/***/ 4334:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/who-is-this-for",
      function () {
        return __webpack_require__(7176);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5562:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-with-text.45ff0eb5.svg","height":190,"width":402});

/***/ }),

/***/ 4641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ ICON_MAP; },
/* harmony export */   "Q4": function() { return /* binding */ NAV_ROUTES; },
/* harmony export */   "RS": function() { return /* binding */ EXAMPLE_PROFILE_URL; },
/* harmony export */   "be": function() { return /* binding */ CONTACT_EMAIL; },
/* harmony export */   "iC": function() { return /* binding */ APP_NAME; }
/* harmony export */ });
/* unused harmony export BASE_URL */
const APP_NAME = "Gwak";
const CONTACT_EMAIL = "contact@getgwak.com";
const BASE_URL = "https://getgwak.com";
const ICON_MAP = {
    Favorites: "/page-assets/images/star-favorites.svg",
    All: "/page-assets/images/lightning.svg"
};
const EXAMPLE_PROFILE_URL = "/profiles/352c42a1-de04-41be-bb83-fc0ca81ecfad";
const NAV_ROUTES = [
    {
        label: "Who is this for?",
        path: "/who-is-this-for"
    },
    {
        label: "Create your own lists",
        path: "/curators"
    },
    {
        label: "Explore profiles",
        path: "/explore"
    },
    // { label: "Consumers", path: "/consumers" },
    {
        label: "About",
        path: "/about"
    }
];


/***/ }),

/***/ 6445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JP": function() { return /* binding */ Reddit; },
/* harmony export */   "O5": function() { return /* binding */ Discord; },
/* harmony export */   "fH": function() { return /* binding */ AppleAppStore; },
/* harmony export */   "kp": function() { return /* binding */ GooglePlay; },
/* harmony export */   "tL": function() { return /* binding */ Twitter; }
/* harmony export */ });
/* unused harmony exports Instagram, Facebook */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);

const GooglePlay = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: "https://play.google.com/store/apps/details?id=com.getgwak.gwak",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/google-play.svg",
            alt: "Google Play Link"
        })
    });
};
const AppleAppStore = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "mr-4",
        href: "https://apps.apple.com/us/app/gwak/id1626025395",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/app-store.svg",
            alt: "Apple App Store link"
        })
    });
};
const Twitter = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50",
        href: "https://twitter.com/gwakhq",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/twitter.svg",
            alt: "Twitter link"
        })
    });
};
const Instagram = ()=>{
    return /*#__PURE__*/ _jsx("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50",
        href: "https://www.instagram.com/gwakhq",
        children: /*#__PURE__*/ _jsx("img", {
            src: "/page-assets/buttons/instagram.svg",
            alt: "Instagram link"
        })
    });
};
const Facebook = ()=>{
    return /*#__PURE__*/ _jsx("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50",
        href: "https://fb.me/gwakhq",
        children: /*#__PURE__*/ _jsx("img", {
            src: "/page-assets/buttons/facebook.svg",
            alt: "Facebook link"
        })
    });
};
const Reddit = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50 p-3",
        href: "https://reddit.com/r/gwakapp",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/reddit.svg",
            alt: "Reddit link"
        })
    });
};
const Discord = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-50 p-3",
        href: "https://discord.gg/PYEpy9VDGy",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/page-assets/buttons/discord.svg",
            alt: "Reddit link"
        })
    });
};


/***/ }),

/***/ 9148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6445);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4641);
/* harmony import */ var _images_logo_with_text_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5562);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8419);






function Footer() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container mx-auto px-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "border-b border-gray-100",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-6 flex flex-wrap items-start items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-5 w-full lg:mb-0 lg:w-1/5",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    className: "inline-block text-xl font-semibold text-gray-900",
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "h-10",
                                        src: _images_logo_with_text_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                        alt: "",
                                        width: "auto"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full lg:w-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "flex flex-wrap items-center space-x-4 text-md lg:space-x-8",
                                    children: [
                                        _constants__WEBPACK_IMPORTED_MODULE_3__/* .NAV_ROUTES.map */ .Q4.map((param)=>/*#__PURE__*/ {
                                            let { label , path  } = param;
                                            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                className: "mb-2 md:mb-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    className: "text-md font-medium",
                                                    href: path,
                                                    children: label
                                                })
                                            }, label);
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-2 md:mb-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "text-md font-medium",
                                                href: "mailto:".concat(_constants__WEBPACK_IMPORTED_MODULE_3__/* .CONTACT_EMAIL */ .be),
                                                children: "Contact Us"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-wrap items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mt-8 text-md text-gray-500",
                                children: [
                                    (0,_util__WEBPACK_IMPORTED_MODULE_5__/* .getPrivacyPolicy */ .FH)(),
                                    " \xa9 ",
                                    _constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_NAME */ .iC,
                                    " 2022"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "order-first mt-8 flex sm:order-last",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .Twitter */ .tL, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .Reddit */ .JP, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .Discord */ .O5, {})
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 2429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ LargeLogoWithText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var _images_logo_with_text_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5562);


const LargeLogoWithText = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: "h-14",
        src: _images_logo_with_text_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src,
        alt: "Gwak logo",
        width: "auto"
    });


/***/ }),

/***/ 2313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Nav; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2429);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4641);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8419);





function Nav() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "py-8 px-4 xl:px-10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            className: "text-xl font-medium",
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_2__/* .LargeLogoWithText */ .s, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "lg:hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "navbar-burger flex items-center rounded p-3 hover:bg-gray-50",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    className: "block h-4 w-4",
                                    viewBox: "0 0 20 20",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                            children: "Mobile menu"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "hidden lg:ml-auto lg:mr-12 lg:flex lg:w-auto lg:items-center lg:space-x-12",
                            children: _constants__WEBPACK_IMPORTED_MODULE_3__/* .NAV_ROUTES.map */ .Q4.map((param)=>/*#__PURE__*/ {
                                let { label , path  } = param;
                                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        className: "text-md font-medium",
                                        href: path,
                                        children: label
                                    })
                                }, path);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden lg:block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-block rounded bg-red-400 py-3 px-8 text-md font-medium leading-normal text-white transition duration-200 hover:bg-red-300",
                                href: "mailto:".concat(_constants__WEBPACK_IMPORTED_MODULE_3__/* .CONTACT_EMAIL */ .be),
                                children: "Contact Us"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "navbar-menu fixed top-0 left-0 bottom-0 z-50 hidden w-5/6 max-w-sm",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "navbar-backdrop fixed inset-0 bg-gray-800 opacity-25"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                        className: "relative flex h-full w-full flex-col overflow-y-auto border-r bg-white py-6 px-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-8 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        className: "mr-auto text-3xl font-medium leading-none",
                                        href: "/",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_2__/* .LargeLogoWithText */ .s, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "navbar-close",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            className: "h-6 w-6 cursor-pointer text-gray-500 hover:text-gray-500",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: "2",
                                                d: "M6 18L18 6M6 6l12 12"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    children: _constants__WEBPACK_IMPORTED_MODULE_3__/* .NAV_ROUTES.map */ .Q4.map((param)=>/*#__PURE__*/ {
                                        let { label , path  } = param;
                                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                className: "block rounded p-4 text-md font-medium text-gray-900 hover:bg-gray-50",
                                                href: path,
                                                children: label
                                            })
                                        }, path);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-6",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "block rounded bg-red-400 py-3 text-center text-md font-medium leading-normal text-white transition duration-200 hover:bg-red-300",
                                            href: "mailto:".concat(_constants__WEBPACK_IMPORTED_MODULE_3__/* .CONTACT_EMAIL */ .be),
                                            children: "Contact Us"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-6 mb-4 text-center text-md text-gray-500",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                "\xa9 2022 ",
                                                (0,_util__WEBPACK_IMPORTED_MODULE_4__/* .getPrivacyPolicy */ .FH)(),
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 8419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kh": function() { return /* binding */ RatingToThumbsIcon; },
  "NZ": function() { return /* binding */ getPriceBadges; },
  "FH": function() { return /* binding */ getPrivacyPolicy; },
  "d4": function() { return /* binding */ getVibeBadges; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./images/ratings/double-thumbs-filled.png
/* harmony default export */ var double_thumbs_filled = ({"src":"/_next/static/media/double-thumbs-filled.fc16622c.png","height":468,"width":468,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEVMaXFmrPGQxPMjiOj///9TpfYQfOr///+12vv4/f9Kn/EskfKcy/WfzfX////E6/9ztfjU6fuRxfV2uvkAcOtstPUkmf9hsPtaKCbkAAAAFnRSTlMA4pT8BP79AnBB9PzlwBcNzoS14v/+81Wg4wAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEBJREFUeJwVzIcVgCAMQMEfWqhiCbr/pj4GuAMUygTVEPIqALnXJI5ytbi8nTxfMh/fjMRkbbiD0aXeylYadvEDRRcB+MUpWzIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./images/ratings/eye.png
/* harmony default export */ var eye = ({"src":"/_next/static/media/eye.a096d318.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEVMaXENpOkOpOkOpusNp+0OpekOpecNo+gQu/8CQyLOAAAACHRSTlMAhq/5mjQ2OKHOeRkAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAsSURBVHicTYtBDgAgCMPWAcr/X2y8iLu0STNpVlCXhB1IdNrZjLwkbVjf9wAPogBwgUFndgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./images/ratings/thumb-down.png
/* harmony default export */ var thumb_down = ({"src":"/_next/static/media/thumb-down.bada9460.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEXwTU3yRETtOzvyRETyRETwQ0PwRETyRETxQ0PyRUX4SEjyRET/SUkbz7VsAAAADHRSTlMB/Q6ZrF987iO7KinLsiCIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nC3GyQ3AMAzEQGp1Obb6rzeIEX44gCQkcGsrD1abjcdDzY+48OBk9iQCthW3ld9eI04A9nixlp4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./images/ratings/thumbs-up.png
/* harmony default export */ var thumbs_up = ({"src":"/_next/static/media/thumbs-up.91924f92.png","height":465,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAJ1BMVEUAq0QVpEoWo0kSoEwVpEoWpUoWpUoUpEoVo0kVn0oWo0oXrk8XqEx0RxixAAAAC3RSTlMBc/0Rn8O0Sfcw2YcluKYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAySURBVHicJcnJDcAgEMBAs0cgMf3XGyH8GskA2ZNTti8ws1xVA8djqBdr90V4Vhn7yx8fyAExNc27JAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/common/util.tsx






const VIBE = {
    hiddenGem: "Hidden Gem",
    lunchSpot: "Lunch Spot",
    quickBite: "Quick Bite",
    weeknightDinner: "Weeknight Dinner",
    dateNight: "Date Night",
    bucketList: "Bucket List"
};
const PRICE = {
    cheap: "Cheap",
    reasonablyPriced: "Reasonably Priced",
    bitPricey: "Bit Pricey",
    expensive: "Expensive"
};
const getVibeBadges = (vibe)=>Object.entries(vibe).filter((param)=>{
        let [key, val] = param;
        return val;
    }).map((param)=>{
        let [key, val] = param;
        return key;
    }).map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-orange-200 text-orange-500 mb-1 mr-1 rounded py-1 px-2 align-middle font-medium",
            children: VIBE[key]
        }, key));
const getPriceBadges = (price)=>Object.entries(price).filter((param)=>{
        let [key, val] = param;
        return val;
    }).map((param)=>{
        let [key, val] = param;
        return key;
    }).map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mb-1 mr-1 rounded bg-green-200 py-1 px-2 align-middle font-medium text-green-500",
            children: PRICE[key]
        }, key));
const getPrivacyPolicy = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/privacy",
        children: "Privacy Policy"
    });
const RatingToThumbsIcon = {
    3: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "h-6",
        src: double_thumbs_filled.src,
        alt: "Two thumbs up"
    }),
    2: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "h-4",
        src: thumbs_up.src,
        alt: "Thumbs up"
    }),
    1: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "h-4",
        src: thumb_down.src,
        alt: "Thumbs down"
    }),
    0: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "h-5",
        src: eye.src,
        alt: "Watchlist"
    })
};


/***/ }),

/***/ 7176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WhoIsThisFor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9148);
/* harmony import */ var _common_nav__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2313);




function WhoIsThisFor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Who is it for? | Gwak"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "For people looking for a better restaurant discovery experience."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_nav__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "absolute top-0 left-0 mt-24 hidden lg:block",
                        src: "/page-assets/icons/dots/blue-dot-left-bars.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "absolute top-0 right-0 mt-40 hidden lg:block",
                        src: "/page-assets/icons/dots/yellow-dot-right-shield.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container mx-auto px-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mx-auto max-w-2xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "font-heading mb-10 text-4xl font-semibold",
                                    children: "Who is this for?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-2 text-xl text-gray-500",
                                    children: "If you're anything like me, you may have experienced any or all of the situations below:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    role: "list",
                                    className: "ml-6 mb-6 list-inside list-disc space-y-2 text-xl italic text-gray-500 marker:text-blue-500",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "You're in a new city and you need to triangulate the \"best\" place to eat between Yelp, Google Maps, Instagram, Tik Tok, Foursquare, etc that fits the groups' tastes."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "You're in a new country and Yelp isn't available, so you resort to Tripadvisor."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Your friend recommends some places to eat and you take a note in your phone only for it to never be looked at again."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "You and some friends try to create and maintain a Google Spreadsheet of restaurant recommendations, but it's a pain to maintain."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Out of town folks ask for some restaurant recommendations and you need to write an essay you've written many times before."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "You found a gem of a place, but only told one friend about it."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "You realize you and another friend have a lot of similar tastes and you would go anywhere they recommend."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "You know a go-to spot that punches well above what its ratings would suggest."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-6 text-xl text-gray-500",
                                    children: "If any of the above apply to you, then I encourage you to try Gwak and experience a more seamless and human-curated sharing of restaurants."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-2 text-xl text-gray-500",
                                    children: "With Gwak, you can:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "ml-6 mb-6 list-inside list-disc space-y-2 text-xl text-gray-500 marker:text-blue-500",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                    children: "Find interesting restaurants"
                                                }),
                                                " from the people you choose to follow"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                "Write your reviews once and ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                    children: "share it with anyone"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                    children: "Find other like-minded people"
                                                }),
                                                " who share similar tastes"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                    children: "Silently unfollow"
                                                }),
                                                " people when you no longer want to see their reviews"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [949,774,888,179], function() { return __webpack_exec__(4334); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);